// extracted by mini-css-extract-plugin
export var subtitle = "_92-2";
export var title = "_92-0";
export var titleNoWrap = "_92-1";